module.exports = __webpack_public_path__ + "img/bg_freevip.d28a5ce6.png";